import { useCallback } from 'react'

import ReactDOM from 'react-dom/client'

import { BridgeService } from '@/services'
import { IS_DEVELOPMENT } from '@/common/constants'
import { changeTheme, enableDarkMode, Theme } from '@interco/inter-ui'

import { WebRouter } from './router'

if (IS_DEVELOPMENT) {
  const { worker } = require('@/common/mocks/handlers')

  worker().start()
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const useApplyAppTheme = () => {
  const getAppInfo = useCallback(async () => {
    const response = await BridgeService.appInfo()

    if (JSON.parse(JSON.stringify(response)).isDarkMode === true) {
      enableDarkMode()
    }

    if (JSON.parse(JSON.stringify(response)).application === 'PJ') changeTheme(Theme.PJ)
    else changeTheme(Theme.PF)
  }, [])

  getAppInfo()
}

const App = () => {
  useApplyAppTheme()

  return <WebRouter />
}

root.render(<App />)
